import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import { CompanyComponent } from './company.component';
import { ComponentsModule } from '../../../components/components.module';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { CompanyEditComponent } from './company-edit/company-edit.component';
import { RouterModule } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import {InvoiceModule} from '../invoice/invoice.module';
import { DatePickerModule } from 'primeng/datepicker';
import { PipesModule } from '../../../pipes/pipes.module';
import { ButtonModule } from 'primeng/button';
import {InputNumberModule} from 'primeng/inputnumber';
import {SelectModule} from 'primeng/select';
import {
    CompanyCostsFormComponent
} from './company-edit/company-costs-form/company-costs-form.component';
import {
    PartnerSelectOrFreeInputComponent
} from './company-edit/partner-select-or-free-input/partner-select-or-free-input.component';


@NgModule({
    declarations: [
        CompanyComponent,
        CompanyEditComponent,
        CompanyCostsFormComponent,
        PartnerSelectOrFreeInputComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        ComponentsModule,
        TableModule,
        ConfirmDialogModule,
        DialogModule,
        RouterModule,
        InputTextModule,
        DropdownModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxModule,
        ToastModule,
        InvoiceModule,
        DatePickerModule,
        PipesModule,
        ButtonModule,
        InputNumberModule,
        SelectModule
    ],
    exports: [CompanyComponent, CompanyEditComponent, CompanyCostsFormComponent, PartnerSelectOrFreeInputComponent]
})
export class CompanyModule { }
